import * as React from 'react';
import * as $ from 'jquery';
import * as _ from 'underscore';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import SelectField from '../../../platform/tsx/SelectField';
import AttributeDesigner from '../../../platform/tsx/attributeDesigner/AttributeDesigner';

import {
    IGlobalFilterControl,
    IGlobalFilterControl_AttributeFilter,
    IGlobalFilterControl_PeriodFilter,
    IAttributeName
} from '../../../platform/tsx/filtering/Interfaces';

import { ITreeItem, IExpression } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

interface IValueUpdateHandler {
    (attributes: IAttributeName[]): IGlobalFilterControl_AttributeFilter;
}

class AttributeFilterControl extends React.Component<
    {
        value?: IGlobalFilterControl_AttributeFilter;
        dataSourceID: number;

        onChange(value: IGlobalFilterControl_AttributeFilter): void;

        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    getValueCopy() {
        return $.extend(true, {}, this.props.value);
    }

    handleIgnoreGlobalFilteringChange = (value: boolean) => {
        const result = this.getValueCopy();

        if (value) {
            result.attributesToAllow = [];
        } else {
            delete result.attributesToAllow;
        }

        this.props.onChange(result);
    };

    getOnAddAttributeHandler(attributes: IAttributeName[], valueUpdateHandler: IValueUpdateHandler) {
        return (values: string[]) => {
            let changed = false;

            _.each(values, (value) => {
                if (
                    _.find(attributes, (attribute) => {
                        return attribute.attribute === value;
                    }) == null
                ) {
                    attributes.push({
                        attribute: value
                    });

                    changed = true;
                }
            });

            if (changed) {
                const result = valueUpdateHandler(attributes);

                this.props.onChange(result);
            }
        };
    }

    getOnAddExpressionHandler(attributes: IAttributeName[], valueUpdateHandler: IValueUpdateHandler) {
        return (value: IExpression) => {
            let changed = false;

            if (
                _.find(attributes, (attribute) => {
                    return (
                        attribute.expression != null &&
                        compareObjects(attribute.expression.syntaxTree, value.syntaxTree)
                    );
                }) == null
            ) {
                attributes.push({
                    expression: value
                });

                changed = true;
            }

            if (changed) {
                const result = valueUpdateHandler(attributes);

                this.props.onChange(result);
            }
        };
    }

    getOnAttributeChangeHandler(attributes: IAttributeName[], index: number, valueChangeHandler: IValueUpdateHandler) {
        return (values: string[]) => {
            attributes[index] = {
                attribute: values[0]
            };

            const result = valueChangeHandler(attributes);

            this.props.onChange(result);
        };
    }

    getOnExpressionChangeHandler(attributes: IAttributeName[], index: number, valueChangeHandler: IValueUpdateHandler) {
        return (value: IExpression) => {
            attributes[index] = {
                expression: value
            };

            const result = valueChangeHandler(attributes);

            this.props.onChange(result);
        };
    }

    getOnRemoveHandler(attributes: IAttributeName[], index: number, valueChangeHandler: IValueUpdateHandler) {
        return () => {
            attributes.splice(index, 1);

            const result = valueChangeHandler(attributes);

            this.props.onChange(result);
        };
    }

    getAttributeElements(
        attributes: IAttributeName[],
        dataSourceID: number,
        tree: ITreeItem[],
        valueChangeHandler: IValueUpdateHandler
    ) {
        return _.map(attributes, (attribute, index) => {
            let value: string | IExpression;

            if (typeof attribute === 'string') {
                //Old format.
                value = attribute;
            } else if (attribute.expression != null) {
                value = attribute.expression;
            } else if (attribute.attribute != null) {
                value = attribute.attribute;
            }

            return (
                <div className="attribute-name" key={'attribute_' + index}>
                    <AttributeDesigner
                        modes={['attribute', 'expression']}
                        value={value}
                        dataSourceID={dataSourceID}
                        tree={tree}
                        showRemoveButton={true}
                        multiselect={false}
                        isForFilter={true}
                        glob={this.props.glob}
                        onChange={this.getOnAttributeChangeHandler(attributes, index, valueChangeHandler)}
                        onExpressionChange={this.getOnExpressionChangeHandler(attributes, index, valueChangeHandler)}
                        onRemove={this.getOnRemoveHandler(attributes, index, valueChangeHandler)}
                    />
                </div>
            );
        });
    }

    attributesToAllowChangeHandler = (attributes: IAttributeName[]) => {
        const result = this.getValueCopy();

        result.attributesToAllow = attributes;

        return result;
    };

    attributesToIgnoreChangeHandler = (attributes: IAttributeName[]) => {
        const result = this.getValueCopy();

        result.attributesToIgnore = attributes;

        return result;
    };

    getRemoveOverrideAttributeRowHandler(index) {
        return () => {
            const result = this.getValueCopy();

            result.attributesToOverride.splice(index, 1);

            this.props.onChange(result);
        };
    }

    getOnOverrideAttributeChangeHandler(isForOld: boolean, index: number) {
        return (values: string[]) => {
            const result = this.getValueCopy();

            if (result.attributesToOverride == null) {
                result.attributesToOverride = [];
            }

            let item: {
                oldAttribute?: string;
                newAttribute?: string;
            };

            if (index != null) {
                item = result.attributesToOverride[index];
            } else {
                result.attributesToOverride.push((item = {}));
            }

            if (isForOld) {
                item.oldAttribute = values[0];
            } else {
                item.newAttribute = values[0];
            }

            this.props.onChange(result);
        };
    }

    getOverrideAttributesRow(
        dataSourceID: number,
        tree: ITreeItem[],
        oldAttribute?: string,
        newAttribute?: string,
        index?: number
    ) {
        let removeElement: React.JSX.Element;

        if (index != null) {
            removeElement = (
                <span
                    className="glyphicon glyphicon-remove"
                    onClick={this.getRemoveOverrideAttributeRowHandler(index)}
                ></span>
            );
        }

        return (
            <tr key={(oldAttribute || 'oldAttribute') + ' : ' + (newAttribute || 'newAttribute') + (index || '')}>
                <td className="cell-remove">{removeElement}</td>

                <td className="cell-old-attribute">
                    <AttributeDesigner
                        value={oldAttribute}
                        dataSourceID={dataSourceID}
                        tree={tree}
                        showRemoveButton={false}
                        multiselect={false}
                        isForFilter={true}
                        glob={this.props.glob}
                        onChange={this.getOnOverrideAttributeChangeHandler(true, index)}
                    />
                </td>

                <td className="cell-new-attribute">
                    <AttributeDesigner
                        value={newAttribute}
                        dataSourceID={dataSourceID}
                        tree={tree}
                        showRemoveButton={false}
                        multiselect={false}
                        isForFilter={true}
                        glob={this.props.glob}
                        onChange={this.getOnOverrideAttributeChangeHandler(false, index)}
                    />
                </td>
            </tr>
        );
    }

    fixFormat(values: any[]): IAttributeName[] {
        if (values == null) {
            return [];
        }

        return _.map(values, (value) => {
            if (typeof value === 'string') {
                //Old format.
                return {
                    attribute: value
                };
            } else {
                return _.clone(value);
            }
        });
    }

    render() {
        const { value, dataSourceID } = this.props;
        const tree = this.props.glob.AttrQueryStore.getEntitiesTreeByDS(dataSourceID);
        const ignoreGlobalFiltering = value != null && value.attributesToAllow != null;

        let attributesToAllowElements: React.JSX.Element;

        if (ignoreGlobalFiltering) {
            const attributesToAllow = value != null ? this.fixFormat(value.attributesToAllow) : [];
            const attributeslements = this.getAttributeElements(
                attributesToAllow,
                dataSourceID,
                tree,
                this.attributesToAllowChangeHandler
            );

            attributesToAllowElements = (
                <div className="attributes-to-allow">
                    <label>{'Ignore all Entities and Attributes except these'}</label>

                    {attributeslements}

                    <div className="attribute-name">
                        <AttributeDesigner
                            modes={['attribute', 'expression']}
                            dataSourceID={dataSourceID}
                            tree={tree}
                            showRemoveButton={false}
                            multiselect={true}
                            isForFilter={true}
                            glob={this.props.glob}
                            onChange={this.getOnAddAttributeHandler(
                                attributesToAllow,
                                this.attributesToAllowChangeHandler
                            )}
                            onExpressionChange={this.getOnAddExpressionHandler(
                                attributesToAllow,
                                this.attributesToAllowChangeHandler
                            )}
                        />
                    </div>
                </div>
            );
        }

        const attributesToIgnore = value != null ? this.fixFormat(value.attributesToIgnore) : [];
        const attributesToIgnoreElements = this.getAttributeElements(
            attributesToIgnore,
            dataSourceID,
            tree,
            this.attributesToIgnoreChangeHandler
        );

        const entitiesTree = this.props.glob.AttrQueryStore.getEntitiesTreeByDS(dataSourceID);

        let attributeToOverrideElements: React.JSX.Element[];

        if (value != null) {
            attributeToOverrideElements = _.map(value.attributesToOverride, (item, index) => {
                return this.getOverrideAttributesRow(
                    dataSourceID,
                    entitiesTree,
                    item.oldAttribute,
                    item.newAttribute,
                    index
                );
            });
        }

        return (
            <div className="attribute-filter-control">
                <div className="component-group ignore-all">
                    <div className="checkbox-field">
                        <BooleanField
                            value={ignoreGlobalFiltering}
                            allowNull={false}
                            title={'Ignore All Global Filtering'}
                            onChange={this.handleIgnoreGlobalFilteringChange}
                        />
                    </div>

                    {attributesToAllowElements}
                </div>

                <div className="component-group attributes-to-ignore">
                    <label>{'Ignore the following Entities and Attributes from Global Filtering'}</label>

                    {attributesToIgnoreElements}

                    <div className="attribute-name">
                        <AttributeDesigner
                            modes={['attribute', 'expression']}
                            dataSourceID={dataSourceID}
                            tree={tree}
                            showRemoveButton={false}
                            multiselect={true}
                            isForFilter={true}
                            glob={this.props.glob}
                            onChange={this.getOnAddAttributeHandler(
                                attributesToIgnore,
                                this.attributesToIgnoreChangeHandler
                            )}
                            onExpressionChange={this.getOnAddExpressionHandler(
                                attributesToIgnore,
                                this.attributesToIgnoreChangeHandler
                            )}
                        />
                    </div>
                </div>

                <div className="component-group attributes-to-override">
                    <label>{'Change Entity/Attribute filters for this Query'}</label>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="cell-remove"></th>

                                <th className="cell-old-attribute">
                                    <span>{'Entity/Attribute in Global Filter'}</span>
                                </th>

                                <th className="cell-new-attribute">
                                    <span>{'Filter on this Entity/Attribute'}</span>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {attributeToOverrideElements}

                            {this.getOverrideAttributesRow(dataSourceID, entitiesTree)}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

class PeriodFilterControl extends React.Component<
    {
        value: IGlobalFilterControl_PeriodFilter;
        dataSourceID: number;

        onChange(value: IGlobalFilterControl_PeriodFilter): void;

        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    handleDefaultPeriodFilteringChange = (value: boolean) => {
        if (value) {
            this.props.onChange(undefined);
        } else {
            this.props.onChange({
                attributes: []
            });
        }
    };

    getValueCopy() {
        return $.extend(true, {}, this.props.value);
    }

    getOnAttributeChangeHandler(index: number, entities: string[]) {
        return (values: string[]) => {
            const result = this.getValueCopy();

            _.each(values, (selectedAttributeName) => {
                let periodType: string;

                if (entities.indexOf(selectedAttributeName) < 0) {
                    //Attribute.
                    periodType = 'event';
                }

                if (index != null) {
                    const existingAttribute = result.attributes[index];

                    existingAttribute.attribute = selectedAttributeName;

                    if (periodType != null) {
                        existingAttribute.periodType = periodType;
                    } else {
                        //Entity has no periodType.
                        delete existingAttribute.periodType;
                    }
                } else {
                    result.attributes.push({
                        attribute: selectedAttributeName,
                        periodType: periodType
                    });
                }
            });

            this.props.onChange(result);
        };
    }

    getOnPeriodTypeChangeHandler(index: number) {
        return (value: string) => {
            const result = this.getValueCopy();
            result.attributes[index].periodType = value;

            this.props.onChange(result);
        };
    }

    getOnAttributeRemoveHandler(index: number) {
        return () => {
            const result = this.getValueCopy();
            result.attributes.splice(index, 1);

            this.props.onChange(result);
        };
    }

    getAttributeRow(
        dataSourceID: number,
        tree: ITreeItem[],
        entities: string[],
        value?: string,
        periodType?: string,
        index?: number
    ) {
        const isAddButton = value == null;

        let attributeElement: React.JSX.Element;

        if (tree.length > 0) {
            attributeElement = (
                <AttributeDesigner
                    value={value}
                    dataSourceID={dataSourceID}
                    tree={tree}
                    showRemoveButton={!isAddButton}
                    multiselect={isAddButton}
                    isForFilter={true}
                    glob={this.props.glob}
                    onChange={this.getOnAttributeChangeHandler(index, entities)}
                    onRemove={this.getOnAttributeRemoveHandler(index)}
                />
            );
        } else {
            attributeElement = <span>{'No Attribute of date type is found'}</span>;
        }

        let periodTypeElement: React.JSX.Element;

        if (periodType != null) {
            periodTypeElement = (
                <SelectField value={periodType} onChange={this.getOnPeriodTypeChangeHandler(index)}>
                    <option value={'event'}>{'Event'}</option>

                    <option value={'start'}>{'Start'}</option>

                    <option value={'end'}>{'End'}</option>
                </SelectField>
            );
        }

        return (
            <tr
                key={'filter ' + (value || 'New') + (index || '')}
                className={isAddButton ? 'add-button' : 'filter-row'}
            >
                <td className="cell-attribute-name">
                    <div>{attributeElement}</div>
                </td>

                <td className="cell-period-type">{periodTypeElement}</td>
            </tr>
        );
    }

    render() {
        const { value, dataSourceID } = this.props;

        let content: React.JSX.Element;

        if (value != null) {
            const entitiesTree = this.props.glob.AttrQueryStore.getEntitiesTreeByDS(dataSourceID);
            const dateTree: ITreeItem[] = [];
            const entities: string[] = [];

            _.each(entitiesTree, (entity) => {
                if (entity.original.IsFunc !== true) {
                    const dateAttributes: ITreeItem[] = [];

                    _.each(entity.children, (attribute) => {
                        const attributeType = attribute.original.type;

                        if (attributeType === 'date' || attributeType === 'datetime' || attributeType === 'time') {
                            dateAttributes.push(attribute);
                        }
                    });

                    if (dateAttributes.length > 0) {
                        const entityCopy = _.clone(entity);

                        entityCopy.children = dateAttributes;
                        dateTree.push(entityCopy);
                        entities.push(entity.name);
                    }
                }
            });

            let attributeRows: React.JSX.Element[];

            if (value.attributes != null) {
                attributeRows = _.map(value.attributes, (attribute, index) => {
                    const attributeName = attribute.attribute || attribute['name']; //EVG 16.02.2021 'name' is an obsolete format.

                    return this.getAttributeRow(
                        dataSourceID,
                        dateTree,
                        entities,
                        attributeName,
                        attribute.periodType,
                        index
                    );
                });
            }

            content = (
                <div className="attributes-to-allow">
                    <label>{'Period Filter should filter on these Entities and Attributes'}</label>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="cell-attribute-name">
                                    <span>{'Entities and Attributes'}</span>
                                </th>

                                <th className="cell-period-type">
                                    <span>{'Period Type'}</span>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {attributeRows}

                            {this.getAttributeRow(dataSourceID, dateTree, entities)}
                        </tbody>
                    </table>
                </div>
            );
        }

        return (
            <div className="component-group period-filter-control">
                <div className="checkbox-field">
                    <BooleanField
                        value={value == null}
                        allowNull={false}
                        title={'Default Period Filtering'}
                        onChange={this.handleDefaultPeriodFilteringChange}
                    />
                </div>

                {content}
            </div>
        );
    }
}

export interface IOptionsDialogProperties {
    value: IGlobalFilterControl;
    dataSourceID: number;
}

export default class AttrQueryFilterOptionsDialog extends React.Component<
    {
        setConfirmValueGetter(getConfirmValue);
        unsetConfirmValueGetter?();

        options: IOptionsDialogProperties;
        glob: IGlob;
    },
    {
        value: IGlobalFilterControl;
    }
> {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.options.value || {}
        };
    }

    private getConfirmValue = () => {
        return this.state.value;
    };

    componentDidMount() {
        var obj = this.props.setConfirmValueGetter(this.getConfirmValue);
    }

    componentWillUnmount() {
        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    getValueCopy() {
        return $.extend(true, {}, this.state.value);
    }

    handleIgnoreAllDeepFilteringChange = (value: boolean) => {
        const stateValue = this.getValueCopy();

        if (value) {
            stateValue.ignoreAllDeepFiltering = value;
        } else {
            delete stateValue.ignoreAllDeepFiltering;
        }

        this.setState({ value: stateValue });
    };

    handleAttributeFilterControlChange = (value: IGlobalFilterControl_AttributeFilter) => {
        const stateValue = this.getValueCopy();

        if (value != null) {
            const { attributesToAllow, attributesToIgnore, attributesToOverride } = value;

            let valueCopy: IGlobalFilterControl_AttributeFilter;

            if (attributesToAllow != null) {
                if (valueCopy == null) {
                    valueCopy = {};
                }

                valueCopy.attributesToAllow = [...attributesToAllow];
            }

            if (attributesToIgnore != null && attributesToIgnore.length > 0) {
                if (valueCopy == null) {
                    valueCopy = {};
                }

                valueCopy.attributesToIgnore = [...attributesToIgnore];
            }

            if (attributesToOverride != null && attributesToOverride.length > 0) {
                if (valueCopy == null) {
                    valueCopy = {};
                }

                valueCopy.attributesToOverride = [...attributesToOverride];
            }

            stateValue.attributeFilter = valueCopy;
        } else {
            delete stateValue.attributeFilter;
        }

        this.setState({ value: stateValue });
    };

    handlePeriodFilterControlChange = (value: IGlobalFilterControl_PeriodFilter) => {
        const stateValue = this.getValueCopy();

        if (value != null) {
            stateValue.periodFilter = value;
        } else {
            delete stateValue.periodFilter;
        }

        this.setState({ value: stateValue });
    };

    render() {
        const { value } = this.state;

        return (
            <div className="attr-query-filter-options-dialog">
                <div className="checkbox-field">
                    <BooleanField
                        value={value.ignoreAllDeepFiltering === true}
                        allowNull={false}
                        title={'Ignore All Deep Filtering'}
                        onChange={this.handleIgnoreAllDeepFilteringChange}
                    />
                </div>

                <AttributeFilterControl
                    value={value.attributeFilter}
                    dataSourceID={this.props.options.dataSourceID}
                    onChange={this.handleAttributeFilterControlChange}
                    glob={this.props.glob}
                />

                <PeriodFilterControl
                    value={value.periodFilter}
                    dataSourceID={this.props.options.dataSourceID}
                    onChange={this.handlePeriodFilterControlChange}
                    glob={this.props.glob}
                />
            </div>
        );
    }
}
